import StationChecklistActionTypes from './station-checklist.types';

const INITIAL_STATE = {
  selectedStation: 'DAL',
  checklist: {},
  error: null,
  loading: true,
};

const stationChecklistReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case StationChecklistActionTypes.FETCH_STATION_CHECKLIST_START:
      return {
        ...state,
        loading: true,
      };
    case StationChecklistActionTypes.FETCH_STATION_CHECKLIST_SUCCESS:
      return {
        ...state,
        checklist: action.payload,
        loading: false,
      };
    case StationChecklistActionTypes.FETCH_STATION_CHECKLIST_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    case StationChecklistActionTypes.SET_SELECTED_STATION_CHECKLIST:
      return {
        ...state,
        selectedStation: action.payload,
      };
    case StationChecklistActionTypes.SET_STATION_CHECKLIST_LOADING:
      return {
        ...state,
        loading: action.payload,
      };

    default:
      return state;
  }
};

export default stationChecklistReducer;
